import { observer } from 'mobx-react';
import React from 'react';
import PlacementTestReportTestDialog from './PlacementTestReportTestDialog';
import placementTestReportTestDialogService from '../services/PlacementTesReportTestDialogService';
import { toJS } from 'mobx';

function PlacementTestReportTestDialogContainer() {
  return (
    <PlacementTestReportTestDialog
      isOpen={placementTestReportTestDialogService.isOpen}
      onClose={placementTestReportTestDialogService.handleCloseDialog}
      isFetching={placementTestReportTestDialogService.fetch.fetching}
      data={toJS(placementTestReportTestDialogService.data)}
    />
  );
}

export default observer(PlacementTestReportTestDialogContainer);
